<template>
  <layout>
    <!-- 去掉多余信息 -->
    <div slot="nav"></div>
    <div slot="sub-nav"></div>
    <div slot="footer-service"></div>
    <!-- 去掉多余信息 -->

    <!-- banner -->
    <div class="banner">
      <div class="container">
        <swiper class="swiper" :options="bannerSwiperOpt">
          <swiper-slide v-for="(item, index) in data.banner" :key="index">
            <a class="banner-link" :href="item.link || 'javascript:void(0)'" :target="item.link?'_blank':'_self'">
              <img class="banner-img" @load="bannerImgLoad(index)" :src="isMobile ? item.imgM : item.img" alt="">
            </a>
          </swiper-slide>
          <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
      </div>
    </div>

    <!-- theme -->
    <div class="theme" id="theme">
      <div class="left section">
        <div class="info">
          <template v-if="isMobile">
            <a class="right" target="_blank" :href="data.theme.link">
              <div class="mask"></div>
              <img :src="data.theme.videobgM" alt="">
              <span class="g-iconfont">&#xe671;</span>
            </a>
          </template>
          <div class="com-title">
            <h2 class="title">{{ data.theme.title }}</h2>
            <h3 class="subtitle">{{ data.theme.subtitle }}</h3>
          </div>
          <p>{{ data.theme.info }}</p>
          <a class="g-btn" target="_blank" :href="data.theme.link">
            <span>查看视频</span>
            <span class="g-iconfont">&#xe66d;</span>
          </a>
        </div>
      </div>
      <template v-if="!isMobile">
        <a class="right" target="_blank" :href="data.theme.link">
          <div class="mask"></div>
          <div class="word">
            <h2>Opening Keynote</h2>
            <img src="~@/image/logo.png" alt="">
          </div>
          <img class="person" :src="data.theme.videobgPerson" alt="">
          <span class="g-iconfont">&#xe671;</span>
        </a>
      </template>
    </div>

    <!-- course -->
    <div class="course section" id="course">
      <div class="container">
        <div class="com-title com-title-dark">
          <div class="title">{{ data.selectedCourse.title }}</div>
          <div class="subtitle">{{ data.selectedCourse.subtitle }}</div>
        </div>

        <p class="info">{{ data.selectedCourse.info }}</p>

        <div class="course-lists">
          <div class="course-list" v-for="(item, index) in data.selectedCourse.list" :key="index">
            <a class="course-list-a" :href="item.link" target="_blank">
              <span class="course-list-index">{{ index + 1 }}</span>
              <h2 class="course-list-title">{{ item.title }}</h2>
              <p class="course-list-info">{{ item.info }}</p>
              <hr class="course-list-hr" :style="{ backgroundColor: item.hrColor }" />
              <div class="course-list-bottom">
                <span class="time-wrap">
                  <!-- <span class="g-iconfont">&#xe66e;</span> -->
                  <img class="g-iconfont-img" src="~@/assets/img/time.png" alt="">
                  <span class="time">{{ item.time }}</span>
                </span>
                <span class="btn">
                  <span>前往查看活动</span>
                  <span class="g-iconfont">&#xe66c;</span>
                </span>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>

    <!-- news -->
    <div class="news section" id="news">
      <div class="container">
        <div class="com-title com-title-dark">
          <div class="title">{{ data.news.title }}</div>
          <div class="subtitle">{{ data.news.subtitle }}</div>
        </div>

        <div class="news-lists">
          <div class="news-list" v-for="(item, index) in news" :key="index">
            <a class="news-list-a" :href="item.link" target="_blank">
              <div class="news-list-img">
                <img :src="item.img" alt="">
                <div class="news-linear-bg"></div>
              </div>
              <div class="news-list-info-wrap">
                <div class="news-list-type">
                  {{ item.type }}
                </div>
                <div class="news-list-title">
                  {{ item.title }}
                </div>
                <div class="news-list-info">
                  {{ item.info }}
                </div>
              </div>
            </a>
          </div>
        </div>

        <div class="next-btn-wrap" v-if="showNewMore" @click="showNewMore = false">
          <span class="next-btn">查看更多</span>
        </div>
      </div>
    </div>

    <!-- video -->
    <div class="video section" id="video">
      <div class="container">
        <div class="com-title com-title-dark">
          <div class="title">{{ data.videos.title }}</div>
          <div class="subtitle">{{ data.videos.subtitle }}</div>
        </div>

        <div class="list-content">
          <template v-if="!isMobile">
            <div class="nav-wrapper">
              <div class="nav-bar">
                <h2>精选视频分类</h2>
                <ul>
                  <li v-for="(item, i) in data.videos.typeList" :key="i" class="type-item"
                  :class="{'active-type': Number(activeType) === item.id}"
                  @click="changeType(item.id)" v-html="item.name"></li>
                </ul>
              </div>
            </div>
          </template>
          <div class="main">
            <template v-if="!isMobile">
              <div class="banner">
                <h2>
                  {{ formateActiveType(activeType) }}
                </h2>
              </div>
            </template>

            <template v-else>
              <div class="nav-bar-m-wrap">
                <ul class="nav-bar-m" ref="navBarM">
                  <li v-for="(item, i) in data.videos.typeList" :key="i" class="type-item"
                  :class="{'active-type': Number(activeType) === item.id}"
                  @click="changeType(item.id)" v-html="item.name"></li>
                </ul>
                <span :style="{ width: `${navBarMHeight}px` }"></span>
              </div>
            </template>

            <div class="list-wrapper">
              <div class="item-wrapper">
                <div class="video-item" v-for="(item, index) in filterVideoData" :key="index">
                  <a class="video-item-a" target="_blank" :href="item.link">
                    <div class="video-item-img">
                      <img :src="item.img" alt="">
                      <span class="g-iconfont">&#xe671;</span>
                    </div>
                    <div class="video-item-info">
                      <div class="video-item-type">{{ formateActiveType(activeType) }}</div>
                      <div class="video-item-title">{{ item.title }}</div>
                      <div class="video-item-word">前往查看视频<span class="g-iconfont">&#xe67c;</span></div>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 左侧 bar -->
    <transition name="gk-slide-in" v-if="!isMobile">
      <WeBar class="webar" :branchList="data.bars" v-if="showBar" />
    </transition>
  </layout>
</template>

<script>
import layout from 'components/layout/Layout'
import WeBar from './We.Bar'

import data from '@/data/next'

import VueBus from '@/utils/vueBus'
import { mapState } from 'vuex'

export default {
  data: () => ({
    data: Object.freeze(data),
    activeType: 1,
    filterVideoData: [],
    eachBranchScroll: [],
    showBar: false,
    showNewMore: true,
    navBarMHeight: 0,
    bannerSwiperOpt: {
      effect: 'slide',
      loop: true,
      speed: 1500,
      autoplay: true,
      pagination: {
        el: '.swiper-pagination',
        clickable: true
      }
    }
  }),
  components: {
    layout,
    WeBar
  },
  methods: {
    changeType (i) {
      this.activeType = i
    },
    formateActiveType (type) {
      return this.data.videos.typeList.filter(item => item.id === type)[0].name
    },
    /**
     * 获取所有分会元素相对屏幕中线的位置 [when scrollTop === 0]
     */
    getBranchClientRect () {
      const pageScrollTop = document.documentElement.scrollTop
      // const clientHeight = document.documentElement.clientHeight

      const branches = document.querySelectorAll('.section')
      branches.forEach(ele => {
        // 因为页面会记住上一次的滚动位置，所以要去除掉 scrollTop 的偏移量
        this.eachBranchScroll.push(ele.getBoundingClientRect().top - 65 + pageScrollTop)
      })
    },
    /**
     * 监听页面 scrollTop 值, 获取进入屏幕中线的 branch 的 index
     */
    listenActiveIndex () {
      const pageScrollTop = document.documentElement.scrollTop

      let index = 0
      while (pageScrollTop > this.eachBranchScroll[index]) {
        ++index
      }
      index -= 1

      VueBus.$emit('setTargetIndex', index)

      if (pageScrollTop > 653) {
        this.showBar = true
      } else {
        this.showBar = false
      }
    },

    scrollToTargetBranchHandler (id) {
      window.removeEventListener('scroll', this.listenActiveIndex)
      this.$scrollTo(`${id}`, 500, {
        offset: this.scrollOffset,
        onDone: () => {
          window.addEventListener('scroll', this.listenActiveIndex)
        }
      })
    },

    bannerImgLoad (index) {
      if (!index) this.getBranchClientRect() 
    }
  },
  computed: {
    ...mapState([
      'isMobile'
    ]),
    scrollOffset () {
      return this.isMobile ? 0 : -65
    },
    news () {
      if (this.showNewMore) {
        return this.data.news.list.slice(0, 6)
      } else {
        return this.data.news.list
      }
    }
  },
  mounted () {
    window.addEventListener('scroll', this.listenActiveIndex)

    VueBus.$on('scrollToTargetBranch', this.scrollToTargetBranchHandler)

    this.$nextTick(() => {
      let navBarM = this.$refs.navBarM
      if (navBarM) this.navBarMHeight = navBarM.scrollWidth
    })
  },

  beforeDestroy () {
    VueBus.$off('scrollToTargetBranch', this.scrollToTargetBranchHandler)
  },
  watch: {
    activeType: {
      handler: function (n, o) {
        this.filterVideoData = []
        this.$nextTick(() => {
          this.filterVideoData = data.videos.videosList.filter(item => item.typeId === n)
        })
      },
      immediate: true
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/style/app.sass';
@import '@/assets/css/_common.scss';
$default-blue: #1973E8;

// common
%word-mobile {
  font-size: 15px;
  line-height: 24px;
}
.container {
  @include mobile {
    width: 90vw;
  }
}
.section {
  padding-top: 84px;
  padding-bottom: 84px;

  @include mobile {
    padding-top: 45px;
    padding-bottom: 45px;
  }
}

.com-title {
  color: #fff;
  .title {
    font-size: 38px; font-weight: 500;
  }
  .subtitle {
    margin-bottom: 28px;
    font-size: 23px;
  }

  &-dark {
    .title {
      color: #202124;
    }
    .subtitle {
      color: #5F6368;
    }
  }

  @include mobile {
    // text-align: center;
    .title {
      font-size: 24px; line-height: 1.4;
    }
    .subtitle {
      font-size: 16px; line-height: 36px;
      margin-bottom: 15px;
    }
  }
}

.banner {
  background: #fff;
  .container {
    padding: 46px 0 92px;
    overflow: hidden;
    width: calc(1280px + 4vw);
    img {
      vertical-align: middle;
    }
    .swiper {
      overflow: visible;
      .swiper-pagination {
        width: auto;
        bottom: -59px; left: 0;

        ::v-deep .swiper-pagination-bullet {
          width: 92px; height: 3px;
          margin: 0 4px;
          border-radius: 0;
          background: rgba(#202124, 0.4);
          transition: all 0.3s linear;
          &-active {
            width: 192px;
            background: #202124;
          }
        }
      }
    }
    .banner-link {
      padding-left: 2vw; padding-right: 2vw;
      .banner-img {
        width: 100%;
      }
    }
  }
}

@include mobile {
  .banner {
    .container {
      padding: 0 0 56px;
      width: 100vw;
      .swiper {
        .swiper-pagination {
          bottom: -37px; left: 5vw;
          ::v-deep .swiper-pagination-bullet {
            width: 60px;
            &-active {
              width: 126px;
            }
          }
        }
      }
      .banner-link {
        padding: 0 5vw;
      }
    }
  }
}

.theme {
  position: relative;
  display: flex;
  .left {
    flex-grow: 1;
    background: url(~@/assets/img/next-theme-bg.png) left/670px no-repeat, $primary1;
    overflow: hidden;
    padding-right: 64px;
    padding-top: 70px;
    padding-bottom: 90px;
    .info {
      padding-left: calc(calc(100vw - 1280px) / 2);
      color: #fff;
      p {
        margin: 26px 0 60px;
        font-size: 17px;
        line-height: 27px;
      }
      .g-btn {
        font-weight: 500;
        border: 1px solid #fff;
        border-radius: 5px;
        padding: 6px 45px;
        color: #fff;
      }
    }
  }
  .right {
    flex: none;
    width: 51.7vw;
    position: relative;
    .mask {
      position: absolute; left: 0; right: 0; bottom: 0; top: 0; z-index: 2;
      background: rgba(#000, 0.1);
    }
    .word {
      position: absolute; left: 44px; bottom: 66px;
      h2 {
        color: rgba(#020102, 0.7);
        font-size: 54px;
        line-height: 54px;
        letter-spacing: -2px;
        margin-bottom: 120px;
        width: 220px;
      }
      img {
        width: 180px;
      }
    }
    .person {
      position: absolute; top: 0; right: 0; bottom: 0;
      height: 100%;
      // img {
      //   height: 100%;
      // }
    }
    .g-iconfont {
      position: absolute; z-index: 2;
      top: 50%; left: 50%;
      transform: translateX(-50%) translateY(-50%);
      font-size: 64px;
      color: #fff;

      @include mobile {
        font-size: 40px;
      }
    }
  }
}

@include mobile {
  .theme {
    flex-direction: column;
    .left {
      padding-top: 40px;
      padding-bottom: 40px;
      padding-right: 4vw;
      padding-left: 4vw;
      background: url(~@/assets/img/next-theme-bg.png) left -190px bottom/570px no-repeat, $primary1;
      .info {
        padding-left: 0;
        text-align: left;
        p {
          margin: 17px 0 28px;
          font-size: 15px; line-height: 24px;
        }
        .g-btn {
          font-size: 14px; line-height: 34px;
          padding: 0px 30px;
        }
      }
    }
    .right {
      width: 100%; height: auto;
      margin-bottom: 15px;
      border-radius: 5px;
      overflow: hidden;
      img {
        width: 100%;
        vertical-align: middle;
      }
    }
  }
}

.course {
  background: #fff;
  .info {
    font-size: 17px; line-height: 27px;
    margin-bottom: 35px;

    @include mobile {
      font-size: 15px; line-height: 24px;
      margin-bottom: 20px;
    }
  }

  .course-lists {
    display: flex; flex-wrap: wrap;
    align-items: stretch;
    margin: -12px;
    .course-list {
      width: 33.33%;
      padding: 12px;
      box-sizing: border-box;
      .course-list-a {
        height: 100%;
        box-sizing: border-box;
        border: 1px solid rgba(218,220,225,1);
        border-radius: 5px;
        padding: 30px;
        .course-list-index {
          font-size: 72px;
          display: block;
          margin-top: -36px;
          margin-bottom: -15px;
          color: #202124;
        }
        .course-list-title {
          font-size: 23px; font-weight: 700;
          line-height: 30px;
          height: 60px;
          @include row(2);
        }
        .course-list-info {
          margin-top: 15px;
          line-height: 26px;
          @include row(3);
        }
        .course-list-hr {
          height: 3px;
          margin: 21px 0 12px;
        }
        .course-list-bottom {
          display: flex; justify-content: space-between; align-items: center;
          .time-wrap {
            font-size: 15px;
            .g-iconfont-img {
              // display: inline-block;
              width: 15px;
              margin-right: 8px;
              transform: translateY(2px);
            }
            .time {
              font-family: PingFang SC !important;
              font-weight: 700; font-size: 16px;
            }
          }
          .btn {
            font-size: 14px; font-weight: 500;
            color: $default-blue;

            .g-iconfont {
              margin-left: 5px;
              font-size: 12px;
            }
          }
        }
      }
    }
  }

  @include mobile {
    .course-lists {
      display: block;
      margin: -7.5px;
      .course-list {
        width: auto;
        padding: 7.5px;
        .course-list-a {
          height: 100%;
          box-sizing: border-box;
          border: 1px solid rgba(218,220,225,1);
          border-radius: 5px;
          padding: 40px 20px 15px;
          .course-list-index {
            font-size: 42px;
            margin-top: -34px;
            margin-bottom: -15px;
          }
          .course-list-title {
            font-size: 18px; font-weight: 700;
            line-height: 26px;
            height: auto;
          }
          .course-list-info {
            margin-top: 8px;
            font-size: 15px; line-height: 22px;
          }
          .course-list-hr {
            height: 3px;
            margin: 21px 0 16px;
          }
          .course-list-bottom {
            display: flex; justify-content: space-between; align-items: center;
            .time-wrap {
              font-size: 15px;
              .g-iconfont {
                display: inline-block;
                margin-right: 8px;
              }
            }
            .btn {
              font-size: 13px; font-weight: 500;

              .g-iconfont {
                margin-left: 5px;
                font-size: 12px;
              }
            }
          }
        }
      }
    }
  }

}

.news {
  background: url(~@/assets/img/new-bg-r.png) top right / 600px no-repeat, url(~@/assets/img/new-bg.png) bottom left / 600px no-repeat, #F7F7F7;
  .news-lists {
    display: flex; flex-wrap: wrap;
    align-items: stretch;
    margin: -12px;
    .news-list {
      width: 33.33%;
      padding: 12px;
      box-sizing: border-box;
      .news-list-a {
        height: 100%;
        box-sizing: border-box;
        // border: 1px solid rgba(218,220,225,1);
        border-radius: 5px;
        box-shadow: 0 4px 8px 0 rgba(7,17,27,.1);
        position: relative;
        z-index: 1;
        background: #fff;
        color: #202124;
        overflow: hidden;
        &:hover {
          box-shadow: 0 8px 16px 0 rgba(7,17,27,.2);
          .news-list-title {
            color: $default-blue;
          }
        }
        .news-list-img  {
          img {
            display: block;
            width: 100%;
          }
          .news-linear-bg {
            height: 6px;
            background: url(~@/assets/img/new-linear.png) center / cover no-repeat;
          }
        }
        .news-list-info-wrap {
          padding: 17px 19px 12px;
          .news-list-type {
            font-size: 12px;
            font-weight: 700;
          }
          .news-list-title {
            line-height: 24px;
            font-size: 19px; font-weight: 700;
            height: 48px;
            margin: 6px 0 10px;
            @include row(2);
          }
          .news-list-info {
            line-height: 23px;
            font-size: 15px;
            @include row(2);
          }
        }
      }
    }
  }

  .next-btn-wrap {
    text-align: center;
    cursor: pointer;
    .next-btn {
      display: inline-block;
      width: 206px;
      text-align: center;
      margin: 38px auto 0;
      border: 1px solid #DADCE1;
      border-radius: 5px;
      line-height: 41px;
      font-size: 15px; font-weight: 700;
      background: #fff;
      color: $default-blue;

      &:hover {
        background: #F8FAFE;
        border: 1px solid #D5E3FA;
      }
    }
  }

  @include mobile {
    .news-lists {
      display: block;
      margin: -7.5px;
      .news-list {
        width: auto;
        padding: 7.5px;
        .news-list-a {
          .news-list-info-wrap {
            .news-list-title {
              font-size: 16px;
              height: auto;
              margin: 5px 0 ;
            }
          }
        }
      }
    }
  }

}

/deep/ {
  .inner-content {
    background: #fff;
  }
}
.list-content {
  display: flex;
  box-sizing: border-box;
  margin-top: 40px;
  // padding: 40px 24px 0;
  .nav-wrapper {
    flex: none;
    .nav-bar {
      h2 {
        margin-bottom: 20px;
        font-weight: 500; line-height: 1;
        font-size: 19px;
        margin-bottom: 28px;
      }
      ul {
        border-left: 2px solid #E0E3E6;
        li {
          margin-bottom: 30px;
          padding-left: 15px;
          font-weight: 400; line-height: 25px;
          font-size: 17px;
          cursor: pointer;
          &.active-type {
            position: relative;
            color: $default-blue;
            font-weight: 700;
            &::before {
              content: '';
              position: absolute; left: -2px; top: 0;
              width: 2px; height: 100%;
              background: $default-blue;
            }
          }
        }
      }
    }
  }
  @include mobile {
    padding: 0;
    margin-top: 9px;
    ::-webkit-scrollbar {
      display: none;
    }
    .nav-wrapper {
      display: none;
    }
    .nav-bar-m-wrap {
      overflow: visible;
      overflow-x: scroll;
      padding-bottom: 15px;
      position: relative;
      span {
        display: block;
        width: 100%; height: 2px;
        position: absolute; bottom: 0px;
        background: #E0E3E6;
      }
      // border-bottom: 2px solid #E0E3E6;
      .nav-bar-m {
        display: flex;
        .type-item {
          margin-right: 30px;
          flex-shrink: 0;
          &:last-child {
            margin-right: 0;
          }

          &.active-type {
            color: $default-blue;
            position: relative;

            &::after {
              content: '';
              position: absolute; bottom: -15px; z-index: 10;
              display: block;
              height: 2px; width: 100%;
              background: $default-blue;
            }
          }
        }
      }
    }
  }
  .main {
    flex: none;
    padding-bottom: 50px;
    margin-left: auto;
    width: 1020px;
    .banner {
      box-sizing: border-box;
      padding: 55px 0 55px 50px;
      margin-bottom: 30px;
      background:rgba(255,255,255,1);
      box-shadow: 0px 3px 10px 1px rgba(0, 0, 0, 0.03);
      background-image: url(~@/assets/img/base-bg-r.png);
      background-repeat: no-repeat;
      background-position: right top;
      background-size: contain;
      border-radius: 5px;
      h2 {
        display: inline-block;
        margin-bottom: 20px;
        font-size: 28px; font-weight: 500; line-height: 1;
        position: relative;
        &::before {
          content: '';
          display: block;
          width: 196px; height: 3px;
          position: absolute; left: 0; right: 0; bottom: -25px;
          background: url(~@/assets/img/base-linear.png) center / cover no-repeat;
        }
      }
    }
    @include mobile {
      width: 100%;
      padding-bottom: 0;
      .banner {
        padding: 30px 20px;
        min-height: 166px;
        background-size: 80%;
        background-position: right top;
        h2 {
          font-size: 26px;
        }
        span {
          font-size: 16px;
        }
      }
    }
  }
  .list-wrapper {
    @include mobile {
      padding-top: 27px;
    }
    .item-wrapper {
      display: flex; flex-wrap: wrap;
      align-items: stretch;
      margin: -12px;
      @include mobile {
        display: block;
      }
      .video-item {
        width: 33.33%;
        padding: 12px;
        box-sizing: border-box;
        @include mobile {
          width: auto;
        }
        .video-item-a {
          height: 100%;
          box-sizing: border-box;
          // border: 1px solid rgba(218,220,225,1);
          border-radius: 5px;
          box-shadow: 0 4px 8px 0 rgba(7,17,27,.1);
          position: relative;
          z-index: 1;
          background: #fff;
          overflow: hidden;
          &:hover {
            box-shadow: 0 8px 16px 0 rgba(7,17,27,.2);
            .video-item-title {
              color: $default-blue !important;
            }
          }
          .video-item-img  {
            position: relative;
            &:hover {
              .g-iconfont {
                color: red;
              }
            }
            img {
              display: block;
              width: 100%;
            }
            .g-iconfont {
              position: absolute; top: 50%; left: 50%; z-index: 1;
              transform: translateX(-50%) translateY(-50%);
              font-size: 46px;
              color: #fff;
            }

            &::after {
              content: '';
              position: absolute; top: 0; left: 0; right: 0; bottom: 0;
              background: rgba(#000, 0.3);
            }
          }
          .video-item-info {
            padding: 17px 19px;
            .video-item-type {
              display: inline-block;
              height: 21px;
              padding: 0 12px;
              font-size: 12px; font-weight: 500;
              border-radius: 10px;
              border: 1px solid #DADCE1;
              color: #5F6368;
              text-align: center;
            }
            .video-item-title {
              line-height: 23px;
              font-size: 17px; font-weight: 500;
              height: 48px;
              margin: 8px 0 10px;
              color: #202124;
              @include mobile {
                height: auto;
              }
            }
            .video-item-word {
              line-height: 23px;
              font-size: 14px; font-weight: 500;
              color: $default-blue;
              // .g-iconfont {
              //   transform: translateY(4px);
              // }
            }
          }
        }
      }
    }
  }
}

@include google-ipad {
  .webar {
    display: none;
  }
  .theme {
    .left {
      display: none;
    }
    .right {
      width: calc(100vw - 200px) !important;
      margin: 0 auto;
      min-height: 508px;
    }
  }
  .course {
    .course-lists {
      .course-list {
        width: 50%;
        .course-list-a {}
      }
    }
  }
  .news {
    .news-lists {
      .news-list {
        width: 50%;
      }
    }
  }
}

</style>
